import { render, staticRenderFns } from "./Section2.vue?vue&type=template&id=39880945&scoped=true"
import script from "./Section2.vue?vue&type=script&lang=js"
export * from "./Section2.vue?vue&type=script&lang=js"
import style0 from "./Section2.vue?vue&type=style&index=0&id=39880945&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39880945",
  null
  
)

export default component.exports